import keyBy from 'lodash/keyBy';
import cloneDeep from 'lodash/cloneDeep';
import { createReducer } from '../../utilities';
import {
    FAIL_GET_ALL_NOTIFICATIONS,
    REQUEST_DELETE_NOTIFICATION,
    REQUEST_GET_ALL_NOTIFICATIONS,
    SUCCESS_DELETE_NOTIFICATION,
    SUCCESS_GET_ALL_NOTIFICATIONS
} from "../../../actions/entities/notificationsCenter";

const initialState = {
    list: null,
    error: false,
    isFetching: false,
};

function requestFetch(state) {
    return {
        ...state,
        isFetching: true,
    };
}

function successFetch(state, action) {
    return {
        ...state,
        list: keyBy(action.response.inAppNotifications, 'id'),
        isFetching: false,
    };
}

function deleteNotification(state, action) {
    const newList = cloneDeep(state.list);
    delete newList[action.notificationId];
    return {
        ...state,
        list: newList,
        isFetching: false,
    };
}

function failFetch(state, action) {
    const { error } = action;
    return {
        ...state,
        isFetching: false,
        error
    };
}

export default createReducer(initialState, {
    [REQUEST_GET_ALL_NOTIFICATIONS]: requestFetch,
    [SUCCESS_GET_ALL_NOTIFICATIONS]: successFetch,
    [FAIL_GET_ALL_NOTIFICATIONS]: failFetch,

    [SUCCESS_DELETE_NOTIFICATION]: deleteNotification,
    [REQUEST_DELETE_NOTIFICATION]: requestFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/notificationsCenter/list.js